import React, { useState } from 'react';
import Title from "../../containers/title/title";
import Gallery from "../../containers/gallery/gallery";
import Form from './form/form';
import classes from "./birthdays.module.css"
import Card from '../card/card';
import Checkout from './checkout/checkout';

const Birthdays = (props) => {
    const [showCheckout, setShowCheckout] = useState(false);
    const [selectedActivities, setSelectedActivities] = useState([]);
    const [selectedDecoration, setSelectedDecoration] = useState([]);
    const [selectedFood, setSelectedFood] = useState([]);
    const [calculationBookingPrice, setCalculationBookingPrice] = useState({});
    
    const toggleActivitiesSelection = (id) => {
        if (selectedActivities.includes(id)) {
            setSelectedActivities(selectedActivities.filter(selected => selected !== id));
        } else {
            setSelectedActivities([id]);
        }
    };
    
    const toggleDecorationSelection = (id) => {
        const existingItem = selectedDecoration.find(selectedId => selectedId === id);
        if (existingItem) {
            setSelectedDecoration(selectedDecoration.filter(selectedId => selectedId !== id));
        } else {
            setSelectedDecoration([id]);
        }
    };
    
    const toggleLiveStationSelection = (item) => {
        let liveStation = { item_id: item.id, quantity: item.quantity, category: 'packages' }
        const existingItem = selectedFood.find(selected => selected.category === liveStation.category);
        if (existingItem) {
            if (existingItem.item_id === liveStation.item_id) {
                setSelectedFood(selectedFood.filter(selected => selected.item_id !== liveStation.item_id));
            } else {
                setSelectedFood(selectedFood.filter(selected => selected.item_id !== existingItem.item_id).concat(liveStation));
            }
        } else {
            setSelectedFood([...selectedFood, liveStation]);
        }
    };

    const currentLang = parseInt(localStorage.getItem('language') || '1');

    return (
        !showCheckout ? <div className={classes.Container}>
            <div className={classes.HeroImage} />
            <div className={classes.Description}>
                {currentLang === 1 
                    ? "YOUR CHILD'S SPECIAL DAY IS ABOUT TO GET MORE SPECIAL" 
                    : "يوم طفلك المميز سيصبح أكثر تميزاً"}
            </div>
            <Title title={currentLang === 1 ? "LET'S PLAN THE PARTY" : "دعنا نخطط للحفلة"} isBirthday />
            <div className={classes.StepTitle}>
                {currentLang === 1 
                    ? "Step1: Choose the activities your kid desires" 
                    : "الخطوة ١: اختر الأنشطة التي يرغب بها طفلك"}
            </div>
            <div className={classes.Note}>
                <div className={classes.Icon}>i</div>
                <div>
                    {currentLang === 1 
                        ? "All packages include 1 hour birthday party" 
                        : "جميع الباقات تشمل حفلة عيد ميلاد لمدة ساعة"}
                </div>
            </div>
            {props.birthdayTypes?.activities?.length > 0 && <ul className={classes.List}>{props.birthdayTypes?.activities?.map((activity) =>
                <Card key={activity.id} name={activity.name} image={activity.image} description={activity.description}
                    onClick={() => toggleActivitiesSelection(activity.id)}
                    class={selectedActivities.find((selected) => selected === activity.id) ? "Selected" : ''} />)
            }
            </ul>}
            {props.services?.length > 0 && <><div className={classes.StepTitle}>
                {currentLang === 1 
                    ? "Step 2 (optional) : Choose area decoration" 
                    : "الخطوة ٢ (اختياري): اختر تزيين المنطقة"}
            </div>
                <ul className={classes.List}>{props.services?.map((service) =>
                    <Card key={service.id} id={service.id} name={service.name} image={service.image}
                        description={service.description} onClick={() => toggleDecorationSelection(service.id)}
                        class={selectedDecoration.find((id) => id === service.id) ? "Selected" : ''} />
                )}
                </ul>
            </>}
            <div className={classes.StepTitle}>
                {currentLang === 1 
                    ? "Step 3 (optional): Choose cake and food" 
                    : "الخطوة ٣ (اختياري): اختر الكيك والطعام"}
            </div>
            {props.cakes?.length > 0 && <>
                <div className={classes.ListTitle}>
                    {currentLang === 1 ? "Cake" : "كيك"}
                </div>
                <ul className={classes.List}>{props.cakes?.map((food) =>
                    <Card key={food.id} hasCounter id={food.id} name={food.name} image={food.image}
                        people={food.serves_people} setSelectedFood={setSelectedFood} selectedFood={selectedFood} />
                )}
                </ul>
            </>}
            {props.pizza?.length > 0 && <>
                <div className={classes.ListTitle}>
                    {currentLang === 1 ? "Pizza" : "بيتزا"}
                </div>
                <ul className={classes.List}>{props.pizza?.map((food) =>
                    <Card key={food.id} hasCounter id={food.id} name={food.name} image={food.image}
                        people={food.serves_people} setSelectedFood={setSelectedFood} selectedFood={selectedFood} />
                )}</ul>
            </>}
            {props.pasta?.length > 0 && <>
                <div className={classes.ListTitle}>
                    {currentLang === 1 ? "Pasta" : "باستا"}
                </div>
                <ul className={classes.List}>{props.pasta?.map((food) =>
                    <Card key={food.id} hasCounter id={food.id} name={food.name} image={food.image}
                        people={food.serves_people} setSelectedFood={setSelectedFood} selectedFood={selectedFood} />
                )}</ul>
            </>}
            {props.burgers?.length > 0 && <>
                <div className={classes.ListTitle}>
                    {currentLang === 1 ? "Burgers & Tenders" : "برجر وتندرز"}
                </div>
                <ul className={classes.List}>{props.burgers?.map((food) =>
                    <Card key={food.id} hasCounter id={food.id} name={food.name} image={food.image}
                        people={food.serves_people} setSelectedFood={setSelectedFood} selectedFood={selectedFood} />
                )}
                </ul></>}
            {props.packages?.length > 0 && <>
                <div className={classes.ListTitle}>
                    {currentLang === 1 ? "Live Stations" : "محطات الطعام المباشرة"}
                </div>
                <ul className={classes.List}>{props.packages?.map((liveStation) =>
                    <Card key={liveStation.id} liveStations shawerma={liveStation.shawerma}
                        burger={liveStation.burger} id={liveStation.id} fries={liveStation.fries} image={liveStation.image}
                        onClick={() => toggleLiveStationSelection(liveStation)}
                        setSelectedFood={setSelectedFood} selectedFood={selectedFood} />)
                }
                </ul>
            </>}
            {props.snacks?.length > 0 && <>
                <div className={classes.ListTitle}>
                    {currentLang === 1 ? "Snacks" : "وجبات خفيفة"}
                </div>
                <ul className={classes.List}>{props.snacks?.map((food) =>
                    <Card key={food.id} hasCounter id={food.id} name={food.name} image={food.image}
                        people={food.serves_people} setSelectedFood={setSelectedFood} selectedFood={selectedFood} />
                )}
                </ul></>}
            <div className={classes.StepTitle}>
                {currentLang === 1 
                    ? "Step 4: Fill up the form" 
                    : "الخطوة ٤: املأ النموذج"}
            </div>
            <Form setShowCheckout={setShowCheckout} showCheckout={showCheckout}
                availableSlots={props.birthdayTypes?.available_slots}
                selectedActivities={selectedActivities}
                selectedDecoration={selectedDecoration}
                selectedFood={selectedFood}
                setBirthdayRegistrationId={props.setBirthdayRegistrationId}
                setBirthdayPaymentData={props.setBirthdayPaymentData} 
                setBirthdayBookingDate={props.setBirthdayBookingDate}
                setCalculationBookingPrice={setCalculationBookingPrice}
                isAuthenticated={props.isAuthenticated}
                setShowLoginForm={props.setShowLoginForm}/>
            {props.imageList?.length > 0 && <>
                <Title title={currentLang === 1 ? "GALLERY" : "معرض الصور"} isBirthday />
                <Gallery images={props.imageList} />
            </>}
        </div> : <Checkout setShowCheckout={setShowCheckout} birthdayRegistrationId={props.birthdayRegistrationId}
            birthdayPaymentData={props.birthdayPaymentData} birthdayBookingDate={props.birthdayBookingDate}
            calculationBookingPrice={calculationBookingPrice}/>
    )
}
export default Birthdays;
